var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1305,
    height: 772,
    viewBox: "0 0 1305 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_738_5242)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_fg_738_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761.015 137.098L972.373 259.126V503.181L761.015 625.209L549.656 503.181V259.126L761.015 137.098Z",
    fill: "url(#paint0_radial_738_5242)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_738_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.85 185.823L718.578 161.418L676.307 185.823V234.634L718.578 259.039L760.85 234.634M760.85 185.823V234.634M760.85 185.823L803.121 161.418L845.392 185.823V234.634L803.121 259.039L760.85 234.634M634.179 259.112L591.908 234.706L549.637 259.112V307.922L591.908 332.328L634.179 307.922M634.179 259.112V307.922M634.179 259.112L676.45 234.706L718.722 259.112V307.922L676.45 332.328L634.179 307.922M718.724 307.94L760.995 332.345V381.156L718.724 405.561L676.453 381.156V332.345L718.724 307.94ZM845.535 234.706L887.806 259.112V307.922L845.535 332.328L803.264 307.922V259.112L845.535 234.706ZM718.727 454.461L760.998 478.867V527.677L718.727 552.083L676.455 527.677V478.867L718.727 454.461ZM676.471 381.16L718.742 405.566V454.376L676.471 478.782L634.2 454.376V405.566L676.471 381.16ZM930.082 234.706L972.354 259.112V307.922L930.082 332.328L887.811 307.922V259.112L930.082 234.706ZM803.264 307.94L845.535 332.345V381.156L803.264 405.561L760.992 381.156V332.345L803.264 307.94ZM803.264 454.461L845.535 478.867V527.677L803.264 552.083L760.992 527.677V478.867L803.264 454.461ZM761.011 381.16L803.282 405.566V454.376L761.011 478.782L718.739 454.376V405.566L761.011 381.16ZM761.011 527.622L803.282 552.028V600.838L761.011 625.244L718.739 600.838V552.028L761.011 527.622ZM634.179 307.94L676.45 332.345V381.156L634.179 405.561L591.908 381.156V332.345L634.179 307.94ZM634.179 454.461L676.45 478.867V527.677L634.179 552.083L591.908 527.677V478.867L634.179 454.461ZM591.926 381.16L634.198 405.566V454.376L591.926 478.782L549.655 454.376V405.566L591.926 381.16ZM887.814 307.94L930.085 332.345V381.156L887.814 405.561L845.543 381.156V332.345L887.814 307.94ZM887.814 454.461L930.085 478.867V527.677L887.814 552.083L845.543 527.677V478.867L887.814 454.461ZM930.098 381.16L972.369 405.566V454.376L930.098 478.782L887.827 454.376V405.566L930.098 381.16ZM760.998 234.706L803.269 259.112V307.922L760.998 332.328L718.726 307.922V259.112L760.998 234.706Z",
    stroke: "white",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760.85 185.823L718.578 161.418L676.307 185.823V234.634L718.578 259.039L760.85 234.634M760.85 185.823V234.634M760.85 185.823L803.121 161.418L845.392 185.823V234.634L803.121 259.039L760.85 234.634M634.179 259.112L591.908 234.706L549.637 259.112V307.922L591.908 332.328L634.179 307.922M634.179 259.112V307.922M634.179 259.112L676.45 234.706L718.722 259.112V307.922L676.45 332.328L634.179 307.922M718.724 307.94L760.995 332.345V381.156L718.724 405.561L676.453 381.156V332.345L718.724 307.94ZM845.535 234.706L887.806 259.112V307.922L845.535 332.328L803.264 307.922V259.112L845.535 234.706ZM718.727 454.461L760.998 478.867V527.677L718.727 552.083L676.455 527.677V478.867L718.727 454.461ZM676.471 381.16L718.742 405.566V454.376L676.471 478.782L634.2 454.376V405.566L676.471 381.16ZM930.082 234.706L972.354 259.112V307.922L930.082 332.328L887.811 307.922V259.112L930.082 234.706ZM803.264 307.94L845.535 332.345V381.156L803.264 405.561L760.992 381.156V332.345L803.264 307.94ZM803.264 454.461L845.535 478.867V527.677L803.264 552.083L760.992 527.677V478.867L803.264 454.461ZM761.011 381.16L803.282 405.566V454.376L761.011 478.782L718.739 454.376V405.566L761.011 381.16ZM761.011 527.622L803.282 552.028V600.838L761.011 625.244L718.739 600.838V552.028L761.011 527.622ZM634.179 307.94L676.45 332.345V381.156L634.179 405.561L591.908 381.156V332.345L634.179 307.94ZM634.179 454.461L676.45 478.867V527.677L634.179 552.083L591.908 527.677V478.867L634.179 454.461ZM591.926 381.16L634.198 405.566V454.376L591.926 478.782L549.655 454.376V405.566L591.926 381.16ZM887.814 307.94L930.085 332.345V381.156L887.814 405.561L845.543 381.156V332.345L887.814 307.94ZM887.814 454.461L930.085 478.867V527.677L887.814 552.083L845.543 527.677V478.867L887.814 454.461ZM930.098 381.16L972.369 405.566V454.376L930.098 478.782L887.827 454.376V405.566L930.098 381.16ZM760.998 234.706L803.269 259.112V307.922L760.998 332.328L718.726 307.922V259.112L760.998 234.706Z",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 465.084 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint1_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M465.084 15L507.356 39.4056V88.2167L465.084 112.622L422.812 88.2167V39.4056L465.084 15Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":838.52441406250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":-154.02005004882812},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 253.737 381.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint2_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.737 381.207L296.008 405.613V454.424L253.737 478.829L211.465 454.424V405.613L253.737 381.207Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":627.17675781250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":212.18698120117188},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 549.647 600.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint3_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M549.647 600.918L591.918 625.324V674.135L549.647 698.54L507.375 674.135V625.324L549.647 600.918Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":923.08691406250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":431.89791870117188},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 1056.89 600.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint4_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1056.89 600.918L1099.16 625.324V674.135L1056.89 698.54L1014.62 674.135V625.324L1056.89 600.918Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":1430.33300781250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":431.89791870117188},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint5_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 1183.72 234.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint5_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint5_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint5_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint5_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1183.72 234.75L1225.99 259.156V307.967L1183.72 332.372L1141.45 307.967V259.156L1183.72 234.75Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":1557.15722656250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":65.729942321777344},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint6_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 1268.27 381.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint6_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint6_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint6_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint6_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1268.27 381.148L1310.54 405.554V454.365L1268.27 478.771L1226 454.365V405.554L1268.27 381.148Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":1641.71191406250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":212.12838745117188},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint7_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 126.947 307.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint7_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint7_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint7_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint7_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.947 307.949L169.219 332.355V381.166L126.947 405.571L84.6758 381.166V332.355L126.947 307.949Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":500.38766479492188,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":138.92916870117188},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint8_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 887.815 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint8_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint8_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint8_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint8_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M887.815 15L930.086 39.4056V88.2167L887.815 112.622L845.543 88.2167V39.4056L887.815 15Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":1261.25488281250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":-154.02005004882812},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint9_diamond_738_5242_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.37344 0 1099.17 88.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    fill: "url(#paint9_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(1 -1)",
    fill: "url(#paint9_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1 1)",
    fill: "url(#paint9_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 116.409,
    transform: "scale(-1)",
    fill: "url(#paint9_diamond_738_5242)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1099.17 88.293L1141.45 112.699V161.51L1099.17 185.915L1056.9 161.51V112.699L1099.17 88.293Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.77918422222137451,\"g\":0.77918422222137451,\"b\":0.77918422222137451,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":0.17643855512142181,\"g\":0.17643855512142181,\"b\":0.17643855512142181,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-746.88043212890625,\"m02\":1472.61425781250,\"m10\":338.04010009765625,\"m11\":7.1014752238418577e-12,\"m12\":-80.727088928222656},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_738_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.466 454.384L253.738 478.789L296.009 454.384V405.573L253.738 381.168L211.466 405.573M211.466 454.384V405.573M211.466 454.384L169.195 478.789L126.924 454.384V405.573L169.195 381.168L211.466 405.573M338.119 185.826L295.848 161.42L253.576 185.826V234.636L295.848 259.042L338.119 234.636M338.119 185.826V234.636M338.119 185.826L380.39 161.42L422.661 185.826V234.636L380.39 259.042L338.119 234.636M634.175 600.913L676.447 625.318V674.129L634.175 698.534L591.904 674.129V625.318L634.175 600.913ZM507.221 527.619L549.493 552.025V600.835L507.221 625.241L464.95 600.835V552.025L507.221 527.619ZM422.82 674.146L465.091 698.551V747.362L422.82 771.767L380.548 747.362V698.551L422.82 674.146ZM676.449 674.146L718.72 698.551V747.362L676.449 771.767L634.178 747.362V698.551L676.449 674.146ZM380.554 600.913L422.825 625.318V674.129L380.554 698.534L338.282 674.129V625.318L380.554 600.913ZM549.638 600.913L591.91 625.318V674.129L549.638 698.534L507.367 674.129V625.318L549.638 600.913ZM465.086 15L507.357 39.4053V88.216L465.086 112.621L422.814 88.216V39.4053L465.086 15ZM549.625 15L591.897 39.4053V88.216L549.625 112.621L507.354 88.216V39.4053L549.625 15ZM549.625 161.457L591.897 185.862V234.673L549.625 259.078L507.354 234.673V185.862L549.625 161.457ZM422.796 88.2986L465.068 112.704V161.515L422.796 185.92L380.525 161.515V112.704L422.796 88.2986ZM380.546 15L422.817 39.4053V88.216L380.546 112.621L338.275 88.216V39.4053L380.546 15ZM422.801 234.708L465.073 259.114V307.924L422.801 332.33L380.53 307.924V259.114L422.801 234.708ZM295.991 454.464L338.262 478.869V527.68L295.991 552.085L253.719 527.68V478.869L295.991 454.464ZM380.53 307.945L422.802 332.35V381.161L380.53 405.566L338.259 381.161V332.35L380.53 307.945ZM126.945 307.945L169.216 332.35V381.161L126.945 405.566L84.6738 381.161V332.35L126.945 307.945ZM42.3846 307.945L84.6559 332.35V381.161L42.3846 405.566L0.113281 381.161V332.35L42.3846 307.945ZM380.53 454.464L422.802 478.869V527.68L380.53 552.085L338.259 527.68V478.869L380.53 454.464ZM338.277 381.168L380.549 405.573V454.384L338.277 478.789L296.006 454.384V405.573L338.277 381.168ZM211.451 454.464L253.722 478.869V527.68L211.451 552.085L169.18 527.68V478.869L211.451 454.464ZM465.078 454.464L507.349 478.869V527.68L465.078 552.085L422.807 527.68V478.869L465.078 454.464ZM507.365 381.168L549.636 405.573V454.384L507.365 478.789L465.093 454.384V405.573L507.365 381.168ZM169.177 234.708L211.448 259.114V307.924L169.177 332.33L126.906 307.924V259.114L169.177 234.708ZM930.076 88.2986L972.347 112.704V161.515L930.076 185.92L887.805 161.515V112.704L930.076 88.2986ZM887.823 15L930.094 39.4053V88.216L887.823 112.621L845.552 88.216V39.4053L887.823 15ZM845.531 88.2986L887.802 112.704V161.515L845.531 185.92L803.26 161.515V112.704L845.531 88.2986ZM803.278 15L845.549 39.4053V88.216L803.278 112.621L761.007 88.216V39.4053L803.278 15ZM1099.16 88.2986L1141.43 112.704V161.515L1099.16 185.92L1056.89 161.515V112.704L1099.16 88.2986ZM1056.91 15L1099.18 39.4053V88.216L1056.91 112.621L1014.64 88.216V39.4053L1056.91 15ZM1141.45 15L1183.72 39.4053V88.216L1141.45 112.621L1099.18 88.216V39.4053L1141.45 15ZM1141.44 307.978L1183.71 332.384V381.194L1141.44 405.6L1099.17 381.194V332.384L1141.44 307.978ZM1141.44 454.5L1183.71 478.905V527.716L1141.44 552.121L1099.17 527.716V478.905L1141.44 454.5ZM1225.98 307.978L1268.25 332.384V381.194L1225.98 405.6L1183.71 381.194V332.384L1225.98 307.978ZM1183.73 381.199L1226 405.604V454.415L1183.73 478.82L1141.46 454.415V405.604L1183.73 381.199ZM1183.73 527.656L1226 552.061V600.872L1183.73 625.277L1141.46 600.872V552.061L1183.73 527.656ZM1056.9 307.978L1099.17 332.384V381.194L1056.9 405.6L1014.63 381.194V332.384L1056.9 307.978ZM1014.65 381.199L1056.92 405.604V454.415L1014.65 478.82L972.376 454.415V405.604L1014.65 381.199ZM1099.17 234.742L1141.44 259.148V307.958L1099.17 332.364L1056.89 307.958V259.148L1099.17 234.742ZM1183.71 234.742L1225.98 259.148V307.958L1183.71 332.364L1141.44 307.958V259.148L1183.71 234.742ZM930.274 674.206L972.545 698.611V747.422L930.274 771.827L888.003 747.422V698.611L930.274 674.206ZM930.133 527.684L972.405 552.09V600.9L930.133 625.306L887.862 600.9V552.09L930.133 527.684ZM1141.63 600.972L1183.9 625.378V674.188L1141.63 698.594L1099.36 674.188V625.378L1141.63 600.972ZM1056.89 600.913L1099.16 625.318V674.129L1056.89 698.534L1014.62 674.129V625.318L1056.89 600.913ZM888.003 600.972L930.274 625.378V674.188L888.003 698.594L845.731 674.188V625.378L888.003 600.972ZM1310.54 454.608L1352.81 479.013V527.824L1310.54 552.23L1268.27 527.824V479.013L1310.54 454.608ZM1352.81 381.157L1395.08 405.563V454.374L1352.81 478.779L1310.54 454.374V405.563L1352.81 381.157ZM1395.1 454.608L1437.37 479.013V527.824L1395.1 552.23L1352.83 527.824V479.013L1395.1 454.608ZM1268.27 381.199L1310.54 405.605V454.416L1268.27 478.821L1225.99 454.416V405.605L1268.27 381.199Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.466 454.384L253.738 478.789L296.009 454.384V405.573L253.738 381.168L211.466 405.573M211.466 454.384V405.573M211.466 454.384L169.195 478.789L126.924 454.384V405.573L169.195 381.168L211.466 405.573M338.119 185.826L295.848 161.42L253.576 185.826V234.636L295.848 259.042L338.119 234.636M338.119 185.826V234.636M338.119 185.826L380.39 161.42L422.661 185.826V234.636L380.39 259.042L338.119 234.636M634.175 600.913L676.447 625.318V674.129L634.175 698.534L591.904 674.129V625.318L634.175 600.913ZM507.221 527.619L549.493 552.025V600.835L507.221 625.241L464.95 600.835V552.025L507.221 527.619ZM422.82 674.146L465.091 698.551V747.362L422.82 771.767L380.548 747.362V698.551L422.82 674.146ZM676.449 674.146L718.72 698.551V747.362L676.449 771.767L634.178 747.362V698.551L676.449 674.146ZM380.554 600.913L422.825 625.318V674.129L380.554 698.534L338.282 674.129V625.318L380.554 600.913ZM549.638 600.913L591.91 625.318V674.129L549.638 698.534L507.367 674.129V625.318L549.638 600.913ZM465.086 15L507.357 39.4053V88.216L465.086 112.621L422.814 88.216V39.4053L465.086 15ZM549.625 15L591.897 39.4053V88.216L549.625 112.621L507.354 88.216V39.4053L549.625 15ZM549.625 161.457L591.897 185.862V234.673L549.625 259.078L507.354 234.673V185.862L549.625 161.457ZM422.796 88.2986L465.068 112.704V161.515L422.796 185.92L380.525 161.515V112.704L422.796 88.2986ZM380.546 15L422.817 39.4053V88.216L380.546 112.621L338.275 88.216V39.4053L380.546 15ZM422.801 234.708L465.073 259.114V307.924L422.801 332.33L380.53 307.924V259.114L422.801 234.708ZM295.991 454.464L338.262 478.869V527.68L295.991 552.085L253.719 527.68V478.869L295.991 454.464ZM380.53 307.945L422.802 332.35V381.161L380.53 405.566L338.259 381.161V332.35L380.53 307.945ZM126.945 307.945L169.216 332.35V381.161L126.945 405.566L84.6738 381.161V332.35L126.945 307.945ZM42.3846 307.945L84.6559 332.35V381.161L42.3846 405.566L0.113281 381.161V332.35L42.3846 307.945ZM380.53 454.464L422.802 478.869V527.68L380.53 552.085L338.259 527.68V478.869L380.53 454.464ZM338.277 381.168L380.549 405.573V454.384L338.277 478.789L296.006 454.384V405.573L338.277 381.168ZM211.451 454.464L253.722 478.869V527.68L211.451 552.085L169.18 527.68V478.869L211.451 454.464ZM465.078 454.464L507.349 478.869V527.68L465.078 552.085L422.807 527.68V478.869L465.078 454.464ZM507.365 381.168L549.636 405.573V454.384L507.365 478.789L465.093 454.384V405.573L507.365 381.168ZM169.177 234.708L211.448 259.114V307.924L169.177 332.33L126.906 307.924V259.114L169.177 234.708ZM930.076 88.2986L972.347 112.704V161.515L930.076 185.92L887.805 161.515V112.704L930.076 88.2986ZM887.823 15L930.094 39.4053V88.216L887.823 112.621L845.552 88.216V39.4053L887.823 15ZM845.531 88.2986L887.802 112.704V161.515L845.531 185.92L803.26 161.515V112.704L845.531 88.2986ZM803.278 15L845.549 39.4053V88.216L803.278 112.621L761.007 88.216V39.4053L803.278 15ZM1099.16 88.2986L1141.43 112.704V161.515L1099.16 185.92L1056.89 161.515V112.704L1099.16 88.2986ZM1056.91 15L1099.18 39.4053V88.216L1056.91 112.621L1014.64 88.216V39.4053L1056.91 15ZM1141.45 15L1183.72 39.4053V88.216L1141.45 112.621L1099.18 88.216V39.4053L1141.45 15ZM1141.44 307.978L1183.71 332.384V381.194L1141.44 405.6L1099.17 381.194V332.384L1141.44 307.978ZM1141.44 454.5L1183.71 478.905V527.716L1141.44 552.121L1099.17 527.716V478.905L1141.44 454.5ZM1225.98 307.978L1268.25 332.384V381.194L1225.98 405.6L1183.71 381.194V332.384L1225.98 307.978ZM1183.73 381.199L1226 405.604V454.415L1183.73 478.82L1141.46 454.415V405.604L1183.73 381.199ZM1183.73 527.656L1226 552.061V600.872L1183.73 625.277L1141.46 600.872V552.061L1183.73 527.656ZM1056.9 307.978L1099.17 332.384V381.194L1056.9 405.6L1014.63 381.194V332.384L1056.9 307.978ZM1014.65 381.199L1056.92 405.604V454.415L1014.65 478.82L972.376 454.415V405.604L1014.65 381.199ZM1099.17 234.742L1141.44 259.148V307.958L1099.17 332.364L1056.89 307.958V259.148L1099.17 234.742ZM1183.71 234.742L1225.98 259.148V307.958L1183.71 332.364L1141.44 307.958V259.148L1183.71 234.742ZM930.274 674.206L972.545 698.611V747.422L930.274 771.827L888.003 747.422V698.611L930.274 674.206ZM930.133 527.684L972.405 552.09V600.9L930.133 625.306L887.862 600.9V552.09L930.133 527.684ZM1141.63 600.972L1183.9 625.378V674.188L1141.63 698.594L1099.36 674.188V625.378L1141.63 600.972ZM1056.89 600.913L1099.16 625.318V674.129L1056.89 698.534L1014.62 674.129V625.318L1056.89 600.913ZM888.003 600.972L930.274 625.378V674.188L888.003 698.594L845.731 674.188V625.378L888.003 600.972ZM1310.54 454.608L1352.81 479.013V527.824L1310.54 552.23L1268.26 527.824V479.013L1310.54 454.608ZM1352.81 381.157L1395.08 405.563V454.374L1352.81 478.779L1310.54 454.374V405.563L1352.81 381.157ZM1395.1 454.608L1437.37 479.013V527.824L1395.1 552.23L1352.83 527.824V479.013L1395.1 454.608ZM1268.26 381.199L1310.54 405.605V454.416L1268.26 478.821L1225.99 454.416V405.605L1268.26 381.199Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_738_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.483 185.904L803.208 210.312V259.126L845.483 283.533L887.757 259.126M718.664 405.676L676.389 430.084V478.898L718.664 503.305M760.938 576.899V625.713M760.792 185.832L718.517 210.239L676.242 185.832M972.31 259.126L930.035 283.533L887.761 259.126M845.339 185.832L803.065 210.239L760.79 185.832M634.111 503.305L676.385 478.898V430.084L634.111 405.676L591.836 430.084V478.898L634.111 503.305ZM634.111 503.305V552.064M887.764 503.305L930.039 478.898V430.084L887.764 405.676L845.49 430.084V478.898L887.764 503.305ZM887.764 503.305V552.064M634.112 259.126L591.837 283.533L549.562 259.126M676.385 185.904L718.659 210.312M718.659 210.312V259.126M718.659 210.312L760.935 185.904L803.209 210.312V259.126L760.935 283.533L718.659 259.126M718.659 259.126L676.385 283.533L634.11 259.126M718.664 259.143L760.938 283.551V332.365L718.664 356.772L676.389 332.365V283.551L718.664 259.143ZM676.403 332.369L718.678 356.777V405.591L676.403 429.998L634.128 405.591V356.777L676.403 332.369ZM803.209 259.143L845.483 283.551V332.365L803.209 356.772L760.934 332.365V283.551L803.209 259.143ZM803.209 405.676L845.483 430.084V478.898L803.209 503.305L760.934 478.898V430.084L803.209 405.676ZM760.951 332.369L803.225 356.777V405.591L760.951 429.998L718.676 405.591V356.777L760.951 332.369ZM760.951 478.842L803.225 503.249V552.064L760.951 576.471L718.676 552.064V503.249L760.951 478.842ZM634.111 259.143L676.385 283.551V332.365L634.111 356.772L591.836 332.365V283.551L634.111 259.143ZM591.855 332.369L634.13 356.777V405.591L591.855 429.998L549.581 405.591V356.777L591.855 332.369ZM887.764 259.143L930.039 283.551V332.365L887.764 356.772L845.49 332.365V283.551L887.764 259.143ZM845.504 332.369L887.778 356.777V405.591L845.504 429.998L803.229 405.591V356.777L845.504 332.369ZM930.051 332.369L972.326 356.777V405.591L930.051 429.998L887.777 405.591V356.777L930.051 332.369Z",
    stroke: "white",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_f_738_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.385 625.305L634.11 649.712L591.836 625.305M507.147 478.784L464.872 503.192V552.006L507.147 576.413L549.421 552.006M422.739 625.322L380.464 649.73V698.544L422.739 722.951M465.013 698.544L422.739 722.951M422.739 722.951V771.825M676.387 625.322L634.113 649.73V698.544L676.387 722.951M718.662 698.544L676.387 722.951M676.387 722.951V771.825M380.469 552.083V503.239M422.744 625.305L380.469 649.712L338.195 625.305M549.567 552.083L507.292 576.491V625.305L549.567 649.712M591.841 625.305L549.567 649.712M549.567 649.712V698.604M507.282 39.3477L465.008 63.7549L422.733 39.3477M549.554 63.7549L507.279 39.3477M549.554 63.7549L591.685 39.4302M549.554 63.7549V112.557M591.828 185.816L549.554 210.223M549.554 210.223L507.279 185.816M549.554 210.223V259.127M422.736 39.3477L380.462 63.7549L338.187 39.3477M422.72 185.851L380.446 210.258V259.073L422.72 283.48L464.995 259.073M295.9 503.252L338.174 478.845V430.031L295.9 405.623L253.625 430.031V478.845L295.9 503.252ZM295.9 503.252V552.083M295.918 405.543L253.644 429.951L211.369 405.543L169.095 429.951L126.82 405.543V356.729L169.095 332.322M295.757 210.186L338.031 185.779L380.305 210.186L422.58 185.779V136.965L380.305 112.557M295.757 210.186L253.482 185.779M295.757 210.186V259.127M380.446 259.093L422.721 283.5V332.315L380.446 356.722L338.171 332.315M126.841 259.093L169.116 283.5V332.315L126.841 356.722L84.5669 332.315M84.549 332.315L42.2745 356.722M42.2745 356.722L0 332.315M42.2745 356.722V405.623M380.446 405.623L338.171 430.031V478.845L380.446 503.252L380.469 503.239M422.721 478.845L380.469 503.239M338.19 332.322L380.464 356.729V405.543L338.19 429.951L295.915 405.543M211.354 503.252L253.628 478.845V430.031L211.354 405.623L169.079 430.031V478.845L211.354 503.252ZM211.354 503.252V552.006M465 405.623L507.274 430.031V478.845L465 503.252L422.725 478.845M549.564 356.729V405.543L507.29 429.951L465.015 405.543M211.351 259.073L169.077 283.48L126.802 259.073M930.034 137.059L887.759 112.652V63.8374L930.177 39.3477M930.034 137.059L972.308 112.652M930.034 137.059V185.888M887.777 63.7549L845.503 39.3477M845.482 137.059L887.757 112.652V63.8374L845.482 39.4302L803.208 63.8374V112.652L845.482 137.059ZM845.482 137.059V185.888M845.501 39.3477L803.226 63.7549L760.952 39.3477M1141.41 63.8374L1099.13 39.4302L1056.86 63.8374V112.652L1099.13 137.059M1141.41 63.8374V112.652M1141.41 63.8374L1183.82 39.3477M1099.13 137.059L1141.6 112.538M1099.13 137.059V185.888L1099.14 185.885M1099.15 39.3477L1056.88 63.7549L1014.6 39.3477M1141.42 63.7549L1099.15 39.3477M1141.42 405.66L1183.69 430.067V478.881L1141.42 503.289L1099.14 478.881M1225.96 259.127L1183.68 283.534V332.348L1225.96 356.756M1225.98 405.575V356.76L1183.71 332.353L1141.43 356.76V405.575L1183.71 429.982L1225.98 405.575ZM1225.98 405.575L1268.29 429.982M1183.71 478.821L1141.43 503.228V552.042L1183.71 576.45L1225.98 552.042M1056.86 259.127L1099.14 283.534V332.348L1056.86 356.756L1014.59 332.348M1014.61 429.982L1056.89 405.575V356.76L1014.61 332.353L972.336 356.76V405.575L1014.61 429.982ZM1014.61 429.982V478.784M1141.41 259.107L1099.14 283.514L1056.86 259.107M1225.96 259.107L1183.69 283.514L1141.41 259.107M930.231 625.382L887.957 649.79V698.604L930.231 723.011M972.506 698.604L930.231 723.011M930.231 723.011V771.825M930.091 478.849L887.816 503.257V552.071L930.091 576.478L972.365 552.071M1141.6 552.143L1183.88 576.55V625.365L1141.6 649.772M1141.6 649.772L1099.33 625.365M1141.6 649.772V698.544M1099.13 625.305L1056.86 649.712M1056.86 649.712L1014.58 625.305M1056.86 649.712V698.604M887.957 552.143L930.231 576.55V625.365L887.957 649.772L845.682 625.365M1268.29 429.982L1309.72 405.66L1352.03 430.067M1268.29 429.982V478.881L1310.56 503.289M1352.03 430.067L1394.45 405.575M1352.03 430.067V478.821M1310.56 503.289L1352.84 478.881L1394.45 502.908M1310.56 503.289V552.042M1394.45 502.908L1436.17 478.821M1394.45 502.908V552.143M422.715 39.4302L464.99 63.8374V112.652L422.715 137.059L380.441 112.652V63.8374L422.715 39.4302ZM1141.42 259.127L1183.69 283.534V332.348L1141.42 356.756L1099.14 332.348V283.534L1141.42 259.127Z",
    stroke: "white",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M676.385 625.305L634.11 649.712L591.836 625.305M507.147 478.784L464.872 503.192V552.006L507.147 576.413L549.421 552.006M422.739 625.322L380.464 649.73V698.544L422.739 722.951M465.013 698.544L422.739 722.951M422.739 722.951V771.825M676.387 625.322L634.113 649.73V698.544L676.387 722.951M718.662 698.544L676.387 722.951M676.387 722.951V771.825M380.469 552.083V503.239M422.744 625.305L380.469 649.712L338.195 625.305M549.567 552.083L507.292 576.491V625.305L549.567 649.712M591.841 625.305L549.567 649.712M549.567 649.712V698.604L507.292 674.197L465.121 698.544M507.282 39.3477L465.008 63.7549L422.733 39.3477M549.554 63.7549L507.279 39.3477M549.554 63.7549L591.685 39.4302M549.554 63.7549V112.557M591.828 185.816L549.554 210.223M549.554 210.223L507.279 185.816M549.554 210.223V259.127M422.736 39.3477L380.462 63.7549L338.187 39.3477M422.72 185.851L380.446 210.258V259.073L422.72 283.48L464.995 259.073M295.9 503.252L338.174 478.845V430.031L295.9 405.623L253.625 430.031V478.845L295.9 503.252ZM295.9 503.252V552.006M295.918 405.543L253.644 429.951L211.369 405.543L169.095 429.951L126.82 405.543V356.729L169.095 332.322M295.757 210.186L338.031 185.779L380.305 210.186L422.58 185.779V136.965L380.305 112.557M295.757 210.186L253.482 185.779M295.757 210.186V259.073M380.446 259.093L422.72 283.5V332.315L380.446 356.722L338.171 332.315M126.841 259.093L169.116 283.5V332.315L126.841 356.722L84.5669 332.315M84.549 332.315L42.2745 356.722M42.2745 356.722L0 332.315M42.2745 356.722V405.623M380.446 405.623L338.171 430.031V478.845L380.446 503.252L380.469 503.239M422.72 478.845L380.469 503.239M338.19 332.322L380.464 356.729V405.543L338.19 429.951L295.915 405.543M211.354 503.252L253.628 478.845V430.031L211.354 405.623L169.079 430.031V478.845L211.354 503.252ZM211.354 503.252V552.083M465 405.623L507.274 430.031V478.845L465 503.252L422.725 478.845M549.564 356.729V405.543L507.29 429.951L465.015 405.543M211.351 259.073L169.077 283.48L126.802 259.073M930.033 137.059L887.759 112.652V63.8374M930.033 137.059L972.308 112.652M930.033 137.059V185.888M845.503 39.3477L887.777 63.7549L929.909 39.4302M845.482 137.059L887.757 112.652V63.8374L845.482 39.4302L803.208 63.8374V112.652L845.482 137.059ZM845.482 137.059V185.888M845.501 39.3477L803.226 63.7549L760.951 39.3477M1141.41 63.8374L1099.13 39.4302L1056.86 63.8374V112.652L1099.13 137.059M1141.41 63.8374V112.652M1141.41 63.8374L1183.82 39.3477M1099.13 137.059L1141.6 112.538M1099.13 137.059V185.888L1099.14 185.885V235.448L1057.49 259.49M1099.15 39.3477L1056.88 63.7549L1014.6 39.3477M1141.42 63.7549L1099.15 39.3477M1141.42 405.66L1183.69 430.067V478.881L1141.42 503.289L1099.14 478.881M1225.96 259.127L1183.68 283.534V332.348L1225.96 356.756M1225.98 356.76L1183.71 332.353L1141.43 356.76V405.575L1183.71 429.982L1225.98 405.575M1225.98 356.76V405.575M1225.98 356.76L1268.29 332.348M1225.98 405.575L1268.29 429.982M1183.71 478.821L1141.43 503.228V552.042L1183.71 576.45L1225.98 552.042M1056.86 259.127L1057.49 259.49M1014.59 332.348L1056.86 356.756L1099.14 332.348V283.534L1057.49 259.49M1014.61 429.982L1056.89 405.575V356.76L1014.61 332.353L972.336 356.76V405.575L1014.61 429.982ZM1014.61 429.982V478.784M1141.41 259.107L1099.14 283.514L1056.86 259.107M1225.96 259.107L1183.69 283.514L1141.41 259.107M930.231 625.382L887.957 649.79V698.604L930.231 723.011M972.506 698.604L930.231 723.011M930.231 723.011V771.825M930.091 478.849L887.816 503.257V552.071L930.091 576.478L972.365 552.071M1141.6 552.143L1183.88 576.55V625.365L1141.6 649.772M1141.6 649.772L1099.33 625.365M1141.6 649.772V698.544M1099.13 625.305L1056.86 649.712M1056.86 649.712L1014.58 625.305M1056.86 649.712V698.604M887.957 552.143L930.231 576.55V625.365L887.957 649.772L845.682 625.365M1268.29 429.982L1310.41 405.66L1352.72 430.067M1268.29 429.982V478.821L1310.41 503.228M1352.72 430.067L1394.85 405.745M1352.72 430.067V478.881M1352.72 478.881L1310.41 503.228M1352.72 478.881L1394.85 503.228M1310.41 503.228V552.042M1394.85 503.228L1439.8 478.784M1394.85 503.228V552.143M422.715 39.4302L464.99 63.8374V112.652L422.715 137.059L380.441 112.652V63.8374L422.715 39.4302ZM1141.42 259.127L1183.69 283.534V332.348L1141.42 356.756L1099.14 332.348V283.534L1141.42 259.127Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeDasharray: "2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.483 185.904L803.208 210.312V259.126L845.483 283.533L887.757 259.126M718.664 405.676L676.389 430.084V478.898L718.664 503.305M760.938 576.899V625.713M760.792 185.832L718.517 210.239L676.242 185.832M972.31 259.126L930.035 283.533L887.761 259.126M845.339 185.832L803.065 210.239L760.79 185.832M634.111 503.305L676.385 478.898V430.084L634.111 405.676L591.836 430.084V478.898L634.111 503.305ZM634.111 503.305V552.064M887.764 503.305L930.039 478.898V430.084L887.764 405.676L845.49 430.084V478.898L887.764 503.305ZM887.764 503.305V552.064M634.112 259.126L591.837 283.533L549.562 259.126M676.385 185.904L718.659 210.312M718.659 210.312V259.126M718.659 210.312L760.935 185.904L803.209 210.312V259.126L760.935 283.533L718.659 259.126M718.659 259.126L676.385 283.533L634.11 259.126M718.664 259.143L760.938 283.551V332.365L718.664 356.772L676.389 332.365V283.551L718.664 259.143ZM676.403 332.369L718.678 356.777V405.591L676.403 429.998L634.128 405.591V356.777L676.403 332.369ZM803.209 259.143L845.483 283.551V332.365L803.209 356.772L760.934 332.365V283.551L803.209 259.143ZM803.209 405.676L845.483 430.084V478.898L803.209 503.305L760.934 478.898V430.084L803.209 405.676ZM760.951 332.369L803.225 356.777V405.591L760.951 429.998L718.676 405.591V356.777L760.951 332.369ZM760.951 478.842L803.225 503.249V552.064L760.951 576.471L718.676 552.064V503.249L760.951 478.842ZM634.111 259.143L676.385 283.551V332.365L634.111 356.772L591.836 332.365V283.551L634.111 259.143ZM591.855 332.369L634.13 356.777V405.591L591.855 429.998L549.581 405.591V356.777L591.855 332.369ZM887.764 259.143L930.039 283.551V332.365L887.764 356.772L845.49 332.365V283.551L887.764 259.143ZM845.504 332.369L887.778 356.777V405.591L845.504 429.998L803.229 405.591V356.777L845.504 332.369ZM930.051 332.369L972.326 356.777V405.591L930.051 429.998L887.777 405.591V356.777L930.051 332.369Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeDasharray: "2.4 2.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_fg_738_5242",
    x: 449.656,
    y: 37.0977,
    width: 622.717,
    height: 688.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_738_5242"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.83333331346511841 0.83333331346511841",
    numOctaves: 3,
    seed: 6348
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "effect1_foregroundBlur_738_5242",
    scale: 24,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_texture_738_5242"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_738_5242",
    x: 537.037,
    y: 148.725,
    width: 447.932,
    height: 489.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_738_5242"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M465.084 15L507.356 39.4056V88.2167L465.084 112.622L422.812 88.2167V39.4056L465.084 15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.737 381.207L296.008 405.613V454.424L253.737 478.829L211.465 454.424V405.613L253.737 381.207Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M549.647 600.918L591.918 625.324V674.135L549.647 698.54L507.375 674.135V625.324L549.647 600.918Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1056.89 600.918L1099.16 625.324V674.135L1056.89 698.54L1014.62 674.135V625.324L1056.89 600.918Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint5_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1183.72 234.75L1225.99 259.156V307.967L1183.72 332.372L1141.45 307.967V259.156L1183.72 234.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint6_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1268.27 381.148L1310.54 405.554V454.365L1268.27 478.771L1226 454.365V405.554L1268.27 381.148Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint7_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.947 307.949L169.219 332.355V381.166L126.947 405.571L84.6758 381.166V332.355L126.947 307.949Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint8_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M887.815 15L930.086 39.4056V88.2167L887.815 112.622L845.543 88.2167V39.4056L887.815 15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint9_diamond_738_5242_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1099.17 88.293L1141.45 112.699V161.51L1099.17 185.915L1056.9 161.51V112.699L1099.17 88.293Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_738_5242",
    x: -12.4867,
    y: 2.30713,
    width: 1462.46,
    height: 782.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_738_5242"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_738_5242",
    x: 541.781,
    y: 178.011,
    width: 438.345,
    height: 454.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6,
    result: "effect1_foregroundBlur_738_5242"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_738_5242",
    x: -14.7,
    y: 24.3373,
    width: 1465.57,
    height: 761.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2,
    result: "effect1_foregroundBlur_738_5242"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_738_5242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(761.015 137.098) rotate(90) scale(347.051 400.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EE7135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6459D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_diamond_738_5242",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#2D2D2D",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_738_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1305,
    height: 772,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.1de6beb153db40da6c733e155829664b.svg";
export { ForwardRef as ReactComponent };